define('views/content/customer_application',['require','views/base/item_page_view','typeahead','bloodhound','text!templates/content/customer_application.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var temp = require("text!templates/content/customer_application.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

                countrySelect: '#country',
                stateSelect: '#state',
                cityField: '.cities-typeahead',
                phoneCountrySelect: '#phone_country',
                contactPhoneCountrySelect: '#contact_phone_country',

                backButton: '#back-button'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged',

            'click @ui.backButton': 'backButtonClicked'
        },

        afterRender: function () {
            var _this = this;

            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'name': "required",
                    'contact_name': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required"
                },
                messages: {
                    'name': App.polyglot.t('name_required'),
                    'contact_name': App.polyglot.t('contact_name_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');

                // Select same country in contact phone number field
                this.ui.contactPhoneCountrySelect.val(country_id);
                this.ui.contactPhoneCountrySelect.trigger('change');

                // Reset state and re render for state options of country
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();

            }
        },

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {

                this.ui.submitButton.addClass('loading');

                grecaptcha.ready(function() {
                    grecaptcha.execute(App.Config.recaptchaKey, {action: 'submit'}).then(function(token) {

                        _this.model.save({recaptchaToken: token}, {
                            success: function (model, response, options) {
                                _this.ui.submitButton.removeClass('loading');
                            
                                App.utils.showMessage('success', App.polyglot.t('customer_application_success'));
                            
                                App.context.redirect('/');
                            },
                            error: function (model, response, options) {
                                _this.ui.submitButton.removeClass('loading');
                            
                                // Show error messages
                                if (response.responseJSON.errors) {
                                    for (var i=0; i<response.responseJSON.errors.length; i++) {
                                        App.utils.showMessage('error', response.responseJSON.errors[i].message);
                                    }
                                }
                            }
                        });

                    });
                });

            }
        },

        backButtonClicked: function () {
            window.history.back();
        }
    });
});
